import { useEffect, useRef, useState } from "react";
import { Alert, Box } from "@mui/material";

const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "204204694583-0c2et8kbk02c5eeq8qjfqbpna8q2d7bh.apps.googleusercontent.com";

let googleScriptPromise;

const loadGoogleScript = () => {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (googleScriptPromise) return googleScriptPromise;

  googleScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(
      'script[src="https://accounts.google.com/gsi/client"]'
    );
    if (existing) {
      existing.addEventListener("load", resolve);
      existing.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return googleScriptPromise;
};

const GoogleAuthButton = ({ label = "signin_with", onCredential, disabled }) => {
  const buttonRef = useRef(null);
  const [scriptError, setScriptError] = useState("");

  useEffect(() => {
    let mounted = true;

    loadGoogleScript()
      .then(() => {
        if (!mounted || !buttonRef.current || !window.google?.accounts?.id) {
          return;
        }

        buttonRef.current.innerHTML = "";
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: (response) => {
            if (!disabled && response?.credential) {
              onCredential(response.credential);
            }
          },
        });
        window.google.accounts.id.renderButton(buttonRef.current, {
          type: "standard",
          theme: "outline",
          size: "large",
          text: label,
          shape: "pill",
          width: buttonRef.current.offsetWidth || 320,
        });
      })
      .catch(() => {
        if (mounted) {
          setScriptError("Google sign in could not load. Please try again.");
        }
      });

    return () => {
      mounted = false;
    };
  }, [disabled, label, onCredential]);

  return (
    <Box sx={{ width: "100%" }}>
      {scriptError && (
        <Alert severity="error" sx={{ mb: 1 }}>
          {scriptError}
        </Alert>
      )}
      <Box
        ref={buttonRef}
        sx={{
          width: "100%",
          minHeight: 44,
          opacity: disabled ? 0.55 : 1,
          pointerEvents: disabled ? "none" : "auto",
          "& > div": { width: "100% !important" },
          iframe: { margin: "0 auto !important" },
        }}
      />
    </Box>
  );
};

export default GoogleAuthButton;
